import { render, staticRenderFns } from "./addVehicleRepairBreakdown.vue?vue&type=template&id=cb5c992e"
import script from "./addVehicleRepairBreakdown.vue?vue&type=script&lang=js"
export * from "./addVehicleRepairBreakdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports